




































































































































import {Component, Mixins, Prop, PropSync, Watch} from 'vue-property-decorator';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';
import ToolTip from '@/components/claim/popup/ToolTip.vue';
import {Amounts, ClaimClassType, ClaimStatusType, ClaimType, ResponsibleObjectType} from '@/types/claim';
import {
  isCancelClaim,
  isCancelExchange,
  isCancelRequest,
  isExchangeClaim,
  isOptionCancel,
  isOrderCancel,
  isReturnClaim,
  isReturnExchange
} from '@/components/claim/popup/validations';
import {
  CouponItem,
  PostOptionCancelsNoPredict,
  PostOptionCancelsNoPredictAmounts,
  ReturnsPredict,
  ReturnsPredictAmounts
} from 'supporter';

type PredictAmounts = PostOptionCancelsNoPredictAmounts | ReturnsPredictAmounts

interface DiscountAmtModified{
  cartCouponDiscountAmt: number, // 주문쿠폰 재계산
  cartCoupon: null | CouponItem // 적용된 쿠폰 정보, null이면 적용된 쿠폰 없음
}

// 배송비변경 row(2)
interface DeliveryAmtModified extends ExchangeShipping{
  claimType: string,
  deliveryDifferenceForDisplay: number,
  exchangeShipping: ExchangeShipping | null
}

interface ExchangeShipping {
  shippingNo: number, // 배송번호
  beforeDeliveryAmt: number, // 변경전배송비
  afterDeliveryAmt: number, // 변경후배송비
  deliveryDifference: number, // 배송비차액
  divided: boolean, //나눔
  combined: boolean, //묶음
  prepaid: boolean, //착불
}

// 할인/배송비 (C), 화면은 비슷하지만 돈계산이 조금씩 다르다.
@Component({
  components: {
    ToolTip
  },
  computed: {
    isCancelRequest,
    isOrderCancel,
    isOptionCancel,
    isCancelClaim,
    isExchangeClaim,
    isReturnClaim,
    isCancelExchange,
    isReturnExchange,
    isSellerResponsible(){
      return this.responsibleObjectType === ResponsibleObjectType.SELLER
    },
    showResponsibleCheckbox(){
      return this.isSellerResponsible
    },
    responsibleCheckboxDisabled(){
      return !this.isModifyMode
    },
    showCouponRestore(){
      return this.claimNoResponseData.claimData.coupon?.cartCoupon?.restores || false
    },
    showExchangeShippingInfo(){
      return this.isCancelExchange && !!this.claimNoResponseData.claimData.exchangeShipping
    },
    payAfterBadge(){
      return !this.deliveryAmtModified.prepaid
    },
    combinedBadge(){
      return this.deliveryAmtModified.combined
    },
    divideBadge(){
      return this.deliveryAmtModified.divided
    },
    beforeDeliveryLineThrough(){
      if(this.isOrderCancel){
        return 'none'
      }

      const {alreadyPaidTotalDeliveryAmt, totalDeliveryAmt} = this.amounts.before.delivery.deliveryGroupAmounts

      return (alreadyPaidTotalDeliveryAmt !== totalDeliveryAmt && this.deliveryAmtModified.prepaid) ? 'line-through' : 'none'
    },

    afterDeliveryLineThrough(){
      // 취소클레임은 변경후 삭선 대신 차액을 전부 삭선함
      if(this.isCancelClaim || this.isCancelExchange){
        return 'none'
      }

      if(this.isReturnClaim || this.isReturnExchange){
        if(this.isSellerResponsible && this.sellerPaysClaimedDeliverySync){
          return this.amounts.returnDelivery?.processedDeliveryAmt > 0 ? 'line-through' : 'none';
        }
        return 'none'
      }

      return 'none'
    },
    differenceLineThrough(){
      if(this.isExchangeClaim){
        return 'none';
      }
      if(this.isSellerResponsible && this.sellerPaysClaimedDeliverySync && this.deliveryAmtModified.deliveryDifference < 0){
        return  'line-through'
      }

      return 'none'
    }
  }
})
export default class DiscountAndDeliveryRecalculate extends Mixins(AmountMixin){
  @Prop({required: true})
  private readonly isModifyMode!: boolean
  @Prop({required: true})
  private claimStatusType!: ClaimStatusType
  @Prop({required: true})
  private readonly reasonType!: boolean
  @Prop({required: true})
  private readonly responsibleObjectType!: ResponsibleObjectType
  @Prop({required: false})
  private readonly predict: null | PostOptionCancelsNoPredict | ReturnsPredict = null
  @PropSync('sellerPaysClaimedDelivery')
  private sellerPaysClaimedDeliverySync!: boolean

  private tooltipOptions = {
    CANCEL: {
      title: 'CLAIM_POPUP_PREPAID_GUIDE',
      toolTipMessageList: [
        'CLAIM_POPUP_PREPAID_GUIDE_MESSAGE_ONE',
        'CLAIM_POPUP_PREPAID_GUIDE_MESSAGE_TWO',
      ]
    },
    EXCHANGE: {
      title: 'CLAIM_POPUP_PREPAID_GUIDE',
      toolTipMessageList: [
        'CLAIM_POPUP_DIVIDE_DELIVERY_MESSAGE',
        'CLAIM_POPUP_PREPAID_GUIDE_MESSAGE_ONE',
        'CLAIM_POPUP_PREPAID_GUIDE_MESSAGE_TWO',
      ]
    },
  }

  @Watch('sellerPaysClaimedDeliverySync')
  private predictAmount(){
    this.$emit('onChangeSellerPaysClaimedDelivery')
  }

  // 할인금액변경 row(1)
  private discountAmtModified: DiscountAmtModified = {
    cartCouponDiscountAmt: 0, // 주문쿠폰 재계산
    cartCoupon: null // 적용된 쿠폰 정보, null이면 적용된 쿠폰 없음
  }

  // 배송비변경 row(2)
  private deliveryAmtModified: DeliveryAmtModified = {
    claimType: '',
    shippingNo: 0, // 배송번호
    beforeDeliveryAmt: 0, // 변경전배송비
    afterDeliveryAmt: 0, // 변경후배송비
    deliveryDifference: 0, // 배송비차액
    deliveryDifferenceForDisplay: 0, // 삭선처리 UI에 쓰일 데이터
    divided: false, //나눔
    combined: false, //묶음
    prepaid: false, //착불
    exchangeShipping: {
      shippingNo: 0,
      deliveryDifference: 0,
      beforeDeliveryAmt: 0,
      afterDeliveryAmt: 0,
      divided: false,
      combined: false,
      prepaid: false,
    }
  }

  // 재계산 합계 row
  private recalculatedAmt = {
    totalAmt: 0
  }

  private get hasCartCoupon(){
    return !!this.discountAmtModified.cartCoupon
  }

  created(){
    this.setDiscountAndDeliveryRecalculateData()
  }

  private setDiscountAndDeliveryRecalculateData(){
    this.setDiscountAmtModified()
    this.setDeliveryAmtModified()
    this.setRecalculatedAmt()
  }

  private setDiscountAmtModified(){
    this.discountAmtModified.cartCouponDiscountAmt =
      this.claimType === ClaimType.EXCHANGE ?
        (-1*this.amounts.refund.coupon.cartCouponDiscountAmt) :
        this.amounts.refund.coupon.cartCouponDiscountAmt;

    const coupon = this.claimNoResponseData.claimData.coupon
    this.discountAmtModified.cartCoupon = (coupon?.cartCoupon || null)
  }

  private setDeliveryAmtModified(){
    const claimType = this.claimNoResponseData.claimType;
    const beforeDeliveryAmt = this.getBeforeDeliveryAmt(this.amounts);
    const afterDeliveryAmt = this.getAfterDeliveryAmt(this.amounts);
    const deliveryDifference = this.getDeliveryDifference(this.amounts)
    const {shippingNo, divided, combined, prepaid} = this.claimNoResponseData.claimData.shipping

    this.setExchangeShipping()

    this.deliveryAmtModified = {
      ...this.deliveryAmtModified,
      claimType,
      shippingNo,
      beforeDeliveryAmt,
      afterDeliveryAmt,
      deliveryDifference,
      deliveryDifferenceForDisplay: deliveryDifference,
      divided,
      combined,
      prepaid
    };
  }

  private getBeforeDeliveryAmt(amounts: Amounts | PredictAmounts){
    if(this.claimNoResponseData.claimClassType === ClaimClassType.ORDER_CANCEL){
      return amounts.before.delivery.totalDeliveryAmt
    }

    return amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt;
  }

  private getAfterDeliveryAmt(amounts: Amounts | PredictAmounts){
    const {claimType, claimClassType} = this.claimNoResponseData

    if(claimType === ClaimType.CANCEL){
      if(claimClassType === ClaimClassType.ORDER_CANCEL){
        return amounts.after.delivery.totalDeliveryAmt
      }

      if(claimClassType === ClaimClassType.OPTION_CANCEL){
        return amounts.after.delivery.deliveryGroupAmounts.totalDeliveryAmt
      }
    }

    if(claimClassType === ClaimClassType.CANCEL_EXCHANGE){
      return amounts.after.delivery.deliveryGroupAmounts.totalDeliveryAmt
    }

    if(claimClassType === ClaimClassType.RETURN_EXCHANGE || claimType === ClaimType.RETURN){
      return amounts.after.delivery.deliveryGroupAmounts.totalDeliveryAmt + (amounts as Amounts).returnDelivery.processedDeliveryAmt;
    }

    return 0;
  }

  private getDeliveryDifference(amounts: Amounts | PredictAmounts){
    const refundDeliveryAmt = (amounts as Amounts).refundDeliveryAmt
    const prepaidProcessedDeliveryAmt =  (amounts as Amounts).returnDelivery?.prepaidProcessedDeliveryAmt ?? 0;

    // 추가결제인 경우
    // TODO: http://localhost:8080/order/detail?orderNo=202103051415306368, 반품교환, 0원결제시 아래조건에 부합되면서 차액이 다르게 나옴
    if (amounts.before.delivery.totalDeliveryAmt <= (amounts.after.delivery.totalDeliveryAmt + prepaidProcessedDeliveryAmt)){
      const difference = refundDeliveryAmt !== 0 ? refundDeliveryAmt : (amounts.refund.delivery.totalDeliveryAmt - prepaidProcessedDeliveryAmt)
      return this.claimType === ClaimType.EXCHANGE ? -1 * difference : difference;
    }

    // else 환불인 경우
    return this.claimType === ClaimType.EXCHANGE ? -1 * refundDeliveryAmt : refundDeliveryAmt;
  }

  private setExchangeShipping(){
    if(!this.claimNoResponseData.claimData.exchangeShipping){
      this.deliveryAmtModified.exchangeShipping = null;
      return
    }

    const {totalPrepaidDeliveryAmt, totalDeliveryAmt} = this.amounts.exchangeDelivery
    const {shippingNo, combined, prepaid, divided} = this.claimNoResponseData.claimData.exchangeShipping
    this.deliveryAmtModified.exchangeShipping = {
      ...this.deliveryAmtModified.exchangeShipping,
      afterDeliveryAmt: totalDeliveryAmt,
      beforeDeliveryAmt: 0,
      deliveryDifference: totalPrepaidDeliveryAmt,
      shippingNo,
      combined,
      prepaid,
      divided
    };
  }

  private setRecalculatedAmt() {
    let result = (-1*this.discountAmtModified.cartCouponDiscountAmt) + (this.isDifferenceAmtLined ? 0 : this.deliveryAmtModified.deliveryDifference)
    if(this.claimType === ClaimType.EXCHANGE && this.claimNoResponseData.claimClassType === ClaimClassType.CANCEL_EXCHANGE){
      // 착불배송비는 재계산합계에서 제외된다.
      result += this.amounts.exchangeDelivery?.totalPrepaidDeliveryAmt ?? 0
    }

    this.recalculatedAmt.totalAmt = result
  }

  private get isDifferenceAmtLined(){
    if(this.claimType === ClaimType.EXCHANGE){
      return false;
    }
    return this.responsibleObjectType === ResponsibleObjectType.SELLER && this.sellerPaysClaimedDeliverySync && this.deliveryAmtModified.deliveryDifference < 0
  }

  // --- 예상 금액 로직 ---
  public resetAsPredictedAmounts(){
    this.setPredictedDiscountAmtModified()
    this.setPredictedDeliveryAmtModified()
    this.setRecalculatedAmt()
  }

  private setPredictedDiscountAmtModified(){
    this.discountAmtModified.cartCouponDiscountAmt = this.predict.amounts.refund.coupon.cartCouponDiscountAmt;
    this.discountAmtModified.cartCoupon = this.predict.coupon.cartCoupon
  }

  private setPredictedDeliveryAmtModified(){
    const beforeDeliveryAmt = this.getBeforeDeliveryAmt(this.predict.amounts);
    const afterDeliveryAmt = this.getAfterDeliveryAmt(this.predict.amounts)
    const deliveryDifference = this.getDeliveryDifference(this.predict.amounts)
    const {divided, combined, prepaid} = this.predict.shipping

    this.deliveryAmtModified = {
      ...this.deliveryAmtModified,
      beforeDeliveryAmt,
      afterDeliveryAmt,
      deliveryDifference,
      divided,
      combined,
      prepaid
    }
  }
}
